<template>
  <pop-over
    :options="popperOptionsComputed"
  >
    <div class="icon-container">
      <i
        class="icon trigger yule-icon-info"
        :class="size"
      />
    </div>
  </pop-over>
</template>
<script>
import PopOver from '@/components/helpers/DataDisplay/PopOver'
export default {
  props: {
    popperOptions: {
      type: Object,
      default: {}
    },
    size: {
      type: String
    }
  },
  components: {
    PopOver
  },
  computed: {
    popperOptionsComputed() {
      return {
        content: this.popperOptions.content,
        options: this.popperOptions
      }
    }
  }
}
</script>
<style lang="sass" scoped>
.small
  font-size: 16px

.icon-container
  height: 20px
  width: 20px
</style>



// WEBPACK FOOTER //
// HelpIcon.vue?1fce700c